import { createAction } from '@reduxjs/toolkit';
import { errorPayloadCreator, getPayloadCreator } from '../core/actionHelpers';
import type { QcsSyncResourcesPayload } from '../core/resourceStoreTypes';
import type { Tax, TaxProps } from './taxesTypes';

const syncTaxPayloadCreator = getPayloadCreator<QcsSyncResourcesPayload<TaxProps>>();
const taxPayloadCreator = getPayloadCreator<Tax>();

export const createTax = createAction('CREATE_TAX', taxPayloadCreator);
export const createTaxSuccess = createAction('CREATE_TAX_SUCCESS', taxPayloadCreator);
export const createTaxFailure = createAction('CREATE_TAX_FAILURE', errorPayloadCreator);

export const updateTax = createAction('UPDATE_TAX', taxPayloadCreator);
export const updateTaxSuccess = createAction('UPDATE_TAX_SUCCESS', taxPayloadCreator);
export const updateTaxFailure = createAction('UPDATE_TAX_FAILURE', errorPayloadCreator);

export const deleteTax = createAction('DELETE_TAX', taxPayloadCreator);
export const deleteTaxSuccess = createAction('DELETE_TAX_SUCCESS', taxPayloadCreator);
export const deleteTaxFailure = createAction('DELETE_TAX_FAILURE', errorPayloadCreator);

export const performTaxCalc = createAction('PERFORM_TAX_CALC', getPayloadCreator());
export const performTaxCalcSuccess = createAction('PERFORM_TAX_CALC_SUCCESS', syncTaxPayloadCreator);
export const performTaxCalcFailure = createAction('PERFORM_TAX_CALC_FAILURE', errorPayloadCreator);

export const getTaxCalculations = createAction('GET_TAX_CALCULATIONS', getPayloadCreator());
export const getTaxCalculationsSuccess = createAction('GET_TAX_CALCULATIONS_SUCCESS', syncTaxPayloadCreator);
export const getTaxCalculationsFailure = createAction('GET_TAX_CALCULATIONS_FAILURE', errorPayloadCreator);

export const getTaxCalculation = createAction('GET_TAX_CALCULATION', getPayloadCreator());
export const getTaxeCalculationSuccess = createAction('GET_TAX_CALCULATION_SUCCESS', syncTaxPayloadCreator);
export const getTaxeCalculationFailure = createAction('GET_TAX_CALCULATION_FAILURE', errorPayloadCreator);
